<template>
  <div v-if="geogrid" class="app-gg-wrapper">
    <GeogridAside
      v-if="!minimalLayout"
      :geogrid="geogrid"
      :logo-path="logoPath"
      @selectCompetitor="selectCompetitor" />

    <GeogridMap
      :geogrid="geogrid"
      :map-key="mapKey"
      :initial-center="[geogrid.attrs.gridCenterLng, geogrid.attrs.gridCenterLat]"
      :features="{
        searchZones: true,
        zipZones: true,
        inmapStats: minimalLayout,
        inmapBusiness: minimalLayout
      }"
      @selectCompetitor="selectCompetitor" />
  </div>
</template>

<script>
import axiosTransform from 'common/axios'

import GeogridAside from './show/geogrid_aside'
import GeogridMap from '../components/geogrid_map'

const fetchGeogrid = (geogridId) => axios.get(`/stats/api/geogrids/${geogridId}`, axiosTransform)

export default {
  components: { GeogridAside, GeogridMap },
  props: {
    geogridId: { type: String, requred: true },
    mapKey: { type: String, required: true },
    logoPath: { type: String, default: '' }
  },
  data() {
    return {
      geogridOrig: null,
      minimalLayout: false,
      showCubes: false,
      showZipcodes: false,
      competitorIndex: -1
    }
  },
  created() {
    this.minimalLayout = window.location.search.includes('minimal')
  },
  computed: {
    geogrid() {
      if (this.competitorIndex === -1) return this.geogridOrig

      const competitor = this.geogridOrig.competitors[this.competitorIndex]
      return {
        ...this.geogridOrig,
        attrs: {
          ...this.geogridOrig.attrs,
          businessName: competitor.name,
          businessAddress: competitor.formattedAddress,
          businessPlaceId: competitor.placeId
        },
        ...competitor.geogrid
      }
    }
  },
  mounted() {
    fetchGeogrid(this.geogridId)
      .then((res) => {
        this.geogridOrig = res.data
      })
  },
  methods: {
    selectCompetitor(competitorIndex) {
      this.competitorIndex = competitorIndex
    }
  }
}
</script>
